import { ActionDropdown } from "../../../controls/api";
import { ComponentEx } from "../../../controls/ComponentEx";
import * as fs from "../../../util/fs";
import getVortexPath from "../../../util/getVortexPath";
import { log } from "../../../util/log";
import { getSafe } from "../../../util/storeHelper";
import { getGame } from "../../gamemode_management/util/getGame";
import TransferIcon from "./TransferIcon";
import { nativeImage } from "electron";
import * as path from "path";
import * as React from "react";
import { pathToFileURL } from "url";
function nop() {
    // nop
}
/**
 * presents profiles and allows creation of new ones
 *
 * @class ProfileView
 * @extends {React.Component<IConnectedProps, {}>}
 */
class ProfileItem extends ComponentEx {
    mUserData;
    mMounted = false;
    constructor(props) {
        super(props);
        this.initState({
            hasProfileImage: false,
            counter: 0,
        });
        this.mUserData = getVortexPath("userData");
    }
    componentDidMount() {
        if (this.props.profile === undefined) {
            this.setHasProfileImage(false);
        }
        else {
            try {
                fs.statAsync(this.imagePath)
                    .then(() => this.setHasProfileImage(true))
                    .catch(() => this.setHasProfileImage(false));
            }
            catch (err) {
                this.setHasProfileImage(false);
            }
        }
        this.mMounted = true;
    }
    componentWillUnmount() {
        this.mMounted = false;
    }
    render() {
        const { t, active, available, features, highlightGameId, mods, profile } = this.props;
        const { counter, hasProfileImage } = this.state;
        const modState = getSafe(profile, ["modState"], {});
        const enabledMods = Object.keys(modState).reduce((prev, key) => {
            return modState[key]?.enabled && mods[key] !== undefined
                ? prev + 1
                : prev;
        }, 0);
        // TODO: not using ListGroupItem because it puts the content into
        //       <p>-tags so it doesn't support 'complex' content
        const classes = ["profile-item"];
        if ((highlightGameId !== undefined && highlightGameId !== profile.gameId) ||
            !available) {
            classes.push("disabled");
        }
        else if (active) {
            classes.push("active");
        }
        const game = getGame(profile.gameId);
        let logo = "";
        try {
            logo =
                hasProfileImage || game === undefined
                    ? this.imagePath
                    : path.join(game.extensionPath, game.logo);
        }
        catch (err) {
            log("warn", "failed to identify profile logo path", {
                profile,
                hasProfileImage,
            });
        }
        const gameName = game?.name !== undefined
            ? game.name
                .split("\t")
                .map((part) => t(part))
                .join(" ")
            : t("Unknown game {{ gameId }}", {
                replace: { gameId: profile.gameId },
            });
        const imageClass = ["profile-image"];
        if (!hasProfileImage) {
            // game images have a different aspect ratio so offset a bit. Makes
            // it more likely to show an "interesting" part of the image
            imageClass.push("offset");
        }
        const actions = this.getActions();
        return (React.createElement("div", { className: classes.join(" "), style: { display: "flex" } },
            React.createElement("div", { style: { flex: "1 1 0" } },
                React.createElement("div", { className: imageClass.join(" "), style: {
                        background: `url('${pathToFileURL(logo).href}?${counter}')`,
                    }, onClick: this.changeImage }),
                React.createElement("h3", { className: "profile-name" }, `${gameName} - ${profile.name}`),
                React.createElement("div", { className: "profile-details" },
                    this.renderFeatureWithValue({
                        id: profile.id + "mods",
                        label: "Mods Enabled",
                        icon: "mods",
                        type: "number",
                        supported: () => true,
                        description: "Number of Mods enabled",
                    }, enabledMods),
                    this.renderFeatureWithValue({
                        id: profile.id + "id",
                        label: "ID",
                        icon: "",
                        type: "string",
                        supported: () => true,
                        description: "Internal ID of this profile",
                    }, profile.id),
                    features.map(this.renderFeature))),
            React.createElement("div", { className: "profile-actions" },
                React.createElement(ActionDropdown, { t: t, group: "profile-actions", orientation: "vertical", className: "menubar", staticElements: actions, buttonType: "both", instanceId: profile.id }),
                React.createElement(TransferIcon, { t: t, disabled: !available, profile: profile, onSetHighlightGameId: this.props.onSetHighlightGameId }))));
    }
    getActions() {
        const { t, active, available } = this.props;
        const res = [];
        if (!active && available) {
            res.push({ icon: "activate", title: "Enable", action: this.activate });
        }
        if (available) {
            res.push({ icon: "edit", title: "Edit", action: this.startEditing });
            res.push({ icon: "clone", title: "Clone", action: this.cloneProfile });
        }
        if (available && process.platform === "win32") {
            res.push({
                icon: "savegame",
                title: "Add Shortcut",
                action: this.createShortcut,
            });
        }
        res.push({ icon: "remove", title: "Remove", action: this.removeProfile });
        return res;
    }
    renderFeature = (feature) => {
        const { profile } = this.props;
        const value = getSafe(profile, ["features", feature.id], undefined);
        return this.renderFeatureWithValue(feature, value);
    };
    renderFeatureWithValue(feature, value) {
        const { t, profile } = this.props;
        const id = `icon-profilefeature-${profile.id}-${feature.id}`;
        return (React.createElement(React.Fragment, { key: id },
            React.createElement("div", { className: "profile-feature-name" },
                React.createElement("a", { className: "fake-link", title: t(feature.description), onClick: nop }, t(feature.label, { ns: feature.namespace }))),
            React.createElement("div", { className: "profile-feature-value" }, this.renderFeatureValue(feature.type, value))));
    }
    renderFeatureValue(type, value) {
        const { t } = this.props;
        if (type === "boolean") {
            return value === true ? t("yes") : t("no");
        }
        else {
            return (value ?? "").toString();
        }
    }
    changeImage = () => {
        this.context.api
            .selectFile({
            filters: [{ name: "Image", extensions: ["jpg", "gif", "png"] }],
        })
            .then((file) => {
            if (file === undefined) {
                return;
            }
            const img = nativeImage.createFromPath(file);
            // TODO: could resize here to save some disc space
            fs.writeFileAsync(this.imagePath, img.toPNG())
                .then(() => {
                this.setHasProfileImage(true);
            })
                .catch((err) => {
                log("warn", "failed to get path for profile image", {
                    profile: this.props.profile,
                });
            });
        });
    };
    setHasProfileImage(hasImage) {
        if (this.mMounted) {
            this.nextState.hasProfileImage = hasImage;
            this.nextState.counter++;
        }
    }
    get imagePath() {
        const { profile } = this.props;
        return path.join(this.mUserData, profile.gameId, "profiles", profile.id, "banner.png");
    }
    cloneProfile = () => {
        const { onClone, profile } = this.props;
        onClone(profile.id);
    };
    removeProfile = () => {
        const { onRemove, profile } = this.props;
        onRemove(profile.id);
    };
    activate = () => {
        const { onActivate, profile } = this.props;
        onActivate(profile.id);
    };
    startEditing = () => {
        const { onStartEditing, profile } = this.props;
        onStartEditing(profile.id);
    };
    createShortcut = () => {
        const { onCreateShortcut, profile } = this.props;
        onCreateShortcut(profile.id);
    };
}
export default ProfileItem;
